/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenMetadataFieldsOtherFieldsInner } from './TokenMetadataFieldsOtherFieldsInner';
import {
    TokenMetadataFieldsOtherFieldsInnerFromJSON,
    TokenMetadataFieldsOtherFieldsInnerFromJSONTyped,
    TokenMetadataFieldsOtherFieldsInnerToJSON,
} from './TokenMetadataFieldsOtherFieldsInner';

/**
 * Fields to be used to extract token metadata from the token response.
 * @export
 * @interface TokenMetadataFields
 */
export interface TokenMetadataFields {
    /**
     * 
     * @type {string}
     * @memberof TokenMetadataFields
     */
    workspaceRefField?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenMetadataFields
     */
    consumerRefField?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenMetadataFields
     */
    scopesField?: string;
    /**
     * Additional fields to extract and transform from the token response
     * @type {Array<TokenMetadataFieldsOtherFieldsInner>}
     * @memberof TokenMetadataFields
     */
    otherFields?: Array<TokenMetadataFieldsOtherFieldsInner>;
}

/**
 * Check if a given object implements the TokenMetadataFields interface.
 */
export function instanceOfTokenMetadataFields(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TokenMetadataFieldsFromJSON(json: any): TokenMetadataFields {
    return TokenMetadataFieldsFromJSONTyped(json, false);
}

export function TokenMetadataFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenMetadataFields {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceRefField': !exists(json, 'workspaceRefField') ? undefined : json['workspaceRefField'],
        'consumerRefField': !exists(json, 'consumerRefField') ? undefined : json['consumerRefField'],
        'scopesField': !exists(json, 'scopesField') ? undefined : json['scopesField'],
        'otherFields': !exists(json, 'otherFields') ? undefined : ((json['otherFields'] as Array<any>).map(TokenMetadataFieldsOtherFieldsInnerFromJSON)),
    };
}

export function TokenMetadataFieldsToJSON(value?: TokenMetadataFields | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceRefField': value.workspaceRefField,
        'consumerRefField': value.consumerRefField,
        'scopesField': value.scopesField,
        'otherFields': value.otherFields === undefined ? undefined : ((value.otherFields as Array<any>).map(TokenMetadataFieldsOtherFieldsInnerToJSON)),
    };
}

